var _defs, _g, _g2, _g3, _g4, _g5, _rect;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgJupyter(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    width: "800px",
    height: "800px",
    viewBox: "0 0 32 32",
    id: "icon",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n      }\n    "))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "logo--jupyter") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "path"
  }, /*#__PURE__*/React.createElement("g", {
    id: "path16_fill",
    "data-name": "path16 fill"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path7_fill",
    "data-name": "path7 fill",
    d: "M26.0766,3.5878a1.69,1.69,0,1,1-1.76-1.5853,1.67,1.67,0,0,1,1.76,1.5853Z"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "path-2",
    "data-name": "path"
  }, /*#__PURE__*/React.createElement("g", {
    id: "path17_fill",
    "data-name": "path17 fill"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path8_fill",
    "data-name": "path8 fill",
    d: "M16.2191,23.1113c-4.4866,0-8.43-1.61-10.4688-3.9882a11.1618,11.1618,0,0,0,20.9377,0C24.6541,21.5011,20.7257,23.1113,16.2191,23.1113Z"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "path-3",
    "data-name": "path"
  }, /*#__PURE__*/React.createElement("g", {
    id: "path18_fill",
    "data-name": "path18 fill"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path9_fill",
    "data-name": "path9 fill",
    d: "M16.2191,7.6483c4.4867,0,8.43,1.61,10.4689,3.9881a11.1618,11.1618,0,0,0-20.9377,0C7.7892,9.2535,11.7126,7.6483,16.2191,7.6483Z"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "path-4",
    "data-name": "path"
  }, /*#__PURE__*/React.createElement("g", {
    id: "path19_fill",
    "data-name": "path19 fill"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path10_fill",
    "data-name": "path10 fill",
    d: "M10.0427,27.7388a2.1085,2.1085,0,1,1-.2031-.7976,2.1278,2.1278,0,0,1,.2031.7976Z"
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "path-5",
    "data-name": "path"
  }, /*#__PURE__*/React.createElement("g", {
    id: "path20_fill",
    "data-name": "path20 fill"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path11_fill",
    "data-name": "path11 fill",
    d: "M6.26,7.1064A1.2263,1.2263,0,1,1,7.4517,5.83,1.2415,1.2415,0,0,1,6.26,7.1064Z"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "_Transparent_Rectangle_",
    "data-name": "<Transparent Rectangle>",
    className: "cls-1",
    width: 32,
    height: 32
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJupyter);
export default __webpack_public_path__ + "static/media/jupyter.b5b3776102205f655d7d40807b56eaf5.svg";
export { ForwardRef as ReactComponent };